import moment from "moment"
import EChartsController from "../echarts_controller"

export default class extends EChartsController {
  static values = {
    data: { type: Array, default: [] },
    interval: { type: String, default: "day" },
    chartOptions: Object,
    dataOptions: Object,
  }

  chartTargetConnected(target) {
    super.chartTargetConnected(target)

    const startDate = moment.utc(target.dataset.startDate)
    const endDate = moment.utc(target.dataset.endDate)
    const ticks = this.generateTicks(startDate, endDate, this.intervalValue)

    this.renderChart(
      this.chart,
      ticks,
      this.intervalValue,
      this.dataValue,
      this.chartOptionsValue || {},
      this.dataOptionsValue || {},
    )
  }

  generateTicks(start, end, interval) {
    const ticks = []
    let current = start.clone()

    const formats = {
      day: {
        tickFormat: "YYYY-MM-DD",
        labelFormat: "MMM D, YYYY",
      },
      week: {
        tickFormat: "YYYY-w",
        labelFormat: "[Week] w, YYYY",
      },
      month: {
        tickFormat: "YYYY-MM",
        labelFormat: "MMM, YYYY",
      },
      year: {
        tickFormat: "YYYY",
        labelFormat: "YYYY",
      },
    }

    const { tickFormat, labelFormat } = formats[interval]

    while (current.isSameOrBefore(end)) {
      ticks.push({
        tick: current.format(tickFormat),
        label: current.format(labelFormat),
      })

      switch (interval) {
        case "day":
          current.add(1, "day")
          break
        case "week":
          current.add(1, "week")
          break
        case "month":
          current.add(1, "month")
          break
        case "year":
          current.add(1, "year")
          break
        default:
          current.add(1, "day")
      }
    }
    return ticks
  }

  renderChart(chart, ticks, interval, data, chartOptions, dataOptions) {
    const tickMapping = {}
    ticks.forEach((t) => {
      tickMapping[t.tick] = t.label
    })

    chart.setOption({
      tooltip: {
        trigger: "axis",
        axisPointer: {
          label: {
            formatter: function (params) {
              return tickMapping[params.value]
            },
          },
        },
      },
      grid: {
        left: "1%",
        right: "1%",
        containLabel: true,
      },
      xAxis: {
        type: "category",
        data: ticks.map((t) => t.tick),
        axisLabel: {
          formatter: function (value) {
            return tickMapping[value]
          },
        },
      },
      yAxis: {
        type: "value",
      },
      ...chartOptions,
      series: data.map((chartData) => ({
        ...dataOptions,
        name: chartData["name"],
        data: chartData["data"],
      })),
    })
  }
}
